export default (str="") => str[0].toUpperCase() + str.slice(1)